import {
  PostAPI,
  PostAPIWithoutRequest,
  PostAPIWithoutRequestAndKeyData,
} from "src/components/api/helper/apiHelper";

export const Insert = async (request: string) => {
  return PostAPI(request, "ProductCategoryMaster/Insert");
};

export const Select = async () => {
  return PostAPIWithoutRequest("ProductCategoryMaster/Select");
};

export const Delete = async (request: string) => {
  return PostAPI(request, "ProductCategoryMaster/Delete");
};

export const Update = async (request: string) => {
  return PostAPI(request, "ProductCategoryMaster/Update");
};

export const SelectByID = async (request: string) => {
  return PostAPI(request, "ProductCategoryMaster/SelectByID");
};

export const ShowProductCategory = async (request: string) => {
  return PostAPI(request, "ProductCategoryMaster/ShowProductCategory");
};

export const ProductCategoryForDropdown = async () => {
  return PostAPIWithoutRequest("ProductCategoryMaster/ProductCategoryForDropdown");
};

export const ProductCategoryForHomePage = async () => {
  return PostAPIWithoutRequestAndKeyData("ProductCategoryMaster/ProductCategoryForHomePage");
};

export const ProductCategoryForShopPage = async () => {
  return PostAPIWithoutRequestAndKeyData("ProductCategoryMaster/ProductCategoryForShopPage");
};
